import React, { FunctionComponent, useCallback, useRef } from "react";

export interface DojoWidgetProps {
	/** CSS class to apply */
	className?: string;
	/** Already created widget to be placed and started up */
	widget: dijit._WidgetBase;
}

export const DojoWidget: FunctionComponent<DojoWidgetProps> = (props) => {
	const {
		widget,
		className,
	} = props;
	const componentRef = useRef<any | null>();
	const contentRef = useCallback(async (domNode) => {
		if (domNode) {
			widget.placeAt(domNode);
			widget.startup();
		} else if (componentRef.current) {
			componentRef.current.destroyRecursive();
			componentRef.current = null;
		}
	}, [widget]);

	return <div className={className} ref={contentRef} />;
};

export default DojoWidget;